<script>

    import { toast } from 'bulma-toast'
    import { tilPricingStore, tilPricingsStore, modalStore } from '../stores'

    import TilService from '../$services/til.service'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'

    let loading = false

    async function deleteTilPricing() {

        loading = true
        const resp = await TilService.deleteTilPricing($tilPricingStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tilPricingsStore.remove($tilPricingStore._id)
        toast({message: 'Precio TIL borrado', type: 'is-success'})

        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard title="Precio TIL">
        <DetailsFields>
            <DetailsField label="Servicio" value={$tilPricingStore.service} />
            <DetailsField label="Peso mín." value={`${$tilPricingStore.volumetricMin} kg`} />
            <DetailsField label="Peso máx." value={`${$tilPricingStore.volumetricMax} kg`} />
            <DetailsField label="Zona origen" value={$tilPricingStore.pickupZoneOperative || '—'} />
            <DetailsField label="Zona destino" value={$tilPricingStore.deliveryZoneOperative || '—'} />
            <DetailsField label="IATA origen" value={$tilPricingStore.pickupIATA || '—'} />
            <DetailsField label="IATA destino" value={$tilPricingStore.deliveryIATA || '—'} />
            <DetailsField label="Precio" value={`$${$tilPricingStore.price}`} mono />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button on:click={() => modalStore.open('tilPricing', 'update_modal', $tilPricingStore)} icon="edit" text="Actualizar" { loading } />
                    <ButtonDelete on:confirm={deleteTilPricing} { loading } />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
